export default {
    ORIGINAL_IMAGE_BASE_URL: "https://s3.amazonaws.com/dailybreak-original-images",
    CONTENT_IMAGE_BASE_URL: "https://s3.amazonaws.com/dailybreak_images_prod",
    TEMP_IMAGE_BASE_URL: "https://s3.amazonaws.com/dailybreak-images-temp",
    TOOLTIP_IMAGE_BASE_URL: "https://s3.amazonaws.com/beaker-tooltips",
    UGC_IMAGE_BASE_URL: "https://s3.amazonaws.com/dbugc_prod",
    BEAKER2_URL: "https://beaker2.dailybreak.com/",
    TEXT_INPUT_DEBOUNCE_TIME: 900,
    SAVE_FIELD_DEBOUNCE_TIME: 100,
    SEARCH_REQUEST_DEBOUNCE_TIME: 500,
    ENABLE_ERROR_WRAPPER: true
};



// WEBPACK FOOTER //
// ./env/base.config.js